import type React from 'react';
import usePermissions from '../hooks/usePermissions';
import type { Permission } from '../permissions';

interface WithPermissionsOptions<P extends object> {
  Component: React.ComponentType<P>;
  permissions: Permission | Permission[];
  requireAll?: boolean;
  fallback?: React.ComponentType<P>;
}

const withPermissions = <P extends object>({ Component, permissions, requireAll = false, fallback: FallbackComponent }: WithPermissionsOptions<P>) => {
  return (props: P) => {
    const { isAccessAllowed, hasAllPermissions } = usePermissions();
    const hasAccess = requireAll ? hasAllPermissions(Array.isArray(permissions) ? permissions : [permissions]) : isAccessAllowed(permissions);

    if (hasAccess) return <Component {...props} />;
    if (FallbackComponent) return <FallbackComponent {...props} />;
    return null;
  };
};

export default withPermissions;
